import React from "react";
import { navLinks, socials } from "../constants/data";

const Footer = () => {
    return (
        <footer className="border-t border-line">
            <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
                <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
                    <div>
                        <p className="font-mono text-sm text-fg">
                            <span className="text-accent">~/</span>harshit.chaunal
                        </p>
                        <p className="mt-2 max-w-xs font-mono text-xs leading-relaxed text-faint">
                            Senior software engineer building full-stack systems and
                            applied AI products.
                        </p>
                    </div>

                    <nav className="flex flex-wrap gap-x-6 gap-y-2">
                        {navLinks.map((link) => (
                            <a
                                key={link.id}
                                href={`#${link.id}`}
                                className="font-mono text-xs uppercase tracking-widest text-muted transition-colors hover:text-accent"
                            >
                                {link.title}
                            </a>
                        ))}
                        <a
                            href={socials.github}
                            target="_blank"
                            rel="noreferrer"
                            className="font-mono text-xs uppercase tracking-widest text-muted transition-colors hover:text-accent"
                        >
                            GitHub ↗
                        </a>
                        <a
                            href={socials.linkedin}
                            target="_blank"
                            rel="noreferrer"
                            className="font-mono text-xs uppercase tracking-widest text-muted transition-colors hover:text-accent"
                        >
                            LinkedIn ↗
                        </a>
                    </nav>
                </div>

                <div className="mt-10 flex flex-col gap-2 border-t border-line pt-6 font-mono text-[11px] text-faint sm:flex-row sm:justify-between">
                    <p>
                        © {new Date().getFullYear()} Harshit Chaunal — designed &
                        engineered by hand.
                    </p>
                    <p>
                        build: v2.1.0 · light + dark ·{" "}
                        <span className="text-accent/70">exit code 0</span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;